<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :class="$style.card"
    :style="style.container"
  >
    <slot />
  </div>
</template>

<script>
  import { CssStyleProcessor } from '@js/vue-style-utils'

  export default {
    name: 'BaseCard',
    inheritAttrs: false,
    props: {
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      styleConfig: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          container: {},
        },
      };
    },
    created: function () {
      const proc = new CssStyleProcessor('--v2-base-card');

      Object.assign(
        this.style.container,
        proc.getExtendedStyle(this.styleConfig.container, 'container'),
      );
    },
  };
</script>

<style lang="stylus" module>
  .card
    background-color (--v2-base-card-card-background-color)
    border (--v2-base-card-card-border)
    border-radius (--v2-base-card-card-border-radius)
    border-width (--v2-base-card-card-border-width)
    box-shadow (--v2-base-card-card-box-shadow)
    &:hover
      background-color (--v2-base-card-card-background-color-hover)
      border (--v2-base-card-card-border-hover)
      border-radius (--v2-base-card-card-border-radius-hover)
      border-width (--v2-base-card-card-border-width-hover)
      box-shadow (--v2-base-card-card-box-shadow-hover)
    &:active
      background-color (--v2-base-card-card-background-color-active)
      border (--v2-base-card-card-border-active)
      border-radius (--v2-base-card-card-border-radius-active)
      border-width (--v2-base-card-card-border-width-active)
      box-shadow (--v2-base-card-card-box-shadow-active)
    &[disabled]
      background-color (--v2-base-card-card-background-color-disabled)
      border (--v2-base-card-card-border-disabled)
      border-radius (--v2-base-card-card-border-radius-disabled)
      border-width (--v2-base-card-card-border-width-disabled)
      box-shadow (--v2-base-card-card-box-shadow-disabled)
</style>
